import { Box } from '@material-ui/core';
import React from 'react';
import { useBasicDetails } from '../../../store/storeApi';
import { TaskItemStatus } from '../../constants';
import { TaskListProgressBarStyleConfig } from '../../interfaces';
import { Task } from '../../interfaces/taskTile';
import { TaskListProgressBarStyles } from './styles/taskListProgressBar';

interface TaskListProgressBarProps {
  tasks: Task[];
  progressBar?: TaskListProgressBarStyleConfig;
}
interface CircleProps {
  task: Task;
}
/** Task List Progress Bar Component */
const TaskListProgressBar = (props: TaskListProgressBarProps): JSX.Element => {
  const { tasks, progressBar } = props;
  const {
    template: { settings },
  } = useBasicDetails();

  const progressBarWithFallBackStyle: TaskListProgressBarStyleConfig = {
    dotColor: progressBar?.dotColor || settings.page.progressBar?.dotColor,
    fillColor: progressBar?.fillColor || settings.page.progressBar?.fillColor,
    outlineColor: progressBar?.outlineColor || settings.page.progressBar?.outlineColor,
  };
  const countNotStartedTask = (): number => {
    let count = 0;
    for (let i = 0; i < tasks.length; i++) {
      if (!tasks[i].status || tasks[i].status === TaskItemStatus.NOT_STARTED) count++; //TODO task status when not started is undefined ? or what?
    }
    return count;
  };
  const classesTaskListProgressBar = TaskListProgressBarStyles(progressBarWithFallBackStyle);
  const notStartedTaskCount = countNotStartedTask();
  const Circle = (props: CircleProps): JSX.Element => {
    const { task } = props;
    if (task.status) {
      if (task.status === TaskItemStatus.IN_PROGRESS || task.status === TaskItemStatus.EVALUATION_PENDING)
        //'Fill circle with border unfilled'
        return <span className={classesTaskListProgressBar.innerCircleFilled}>{'inner'}</span>;
      //Both circle and Circle Border Filled
      else return <span className={classesTaskListProgressBar.circleFilled}>{'filled'}</span>;
    } else {
      //No fill in the circle
      return <span className={classesTaskListProgressBar.circleUnfilled}>{'unfilled'}</span>;
    }
  };
  if (notStartedTaskCount === tasks.length) return <></>;
  //Not to show progress bar when someone lands in the task page for the first time
  else
    return (
      <Box className={classesTaskListProgressBar.progressBar}>
        <ul className={classesTaskListProgressBar.progressBullets}>
          {tasks.map((task: Task, index: number) => {
            return (
              <li key={index}>
                <Circle task={task} />{' '}
              </li>
            );
          })}
        </ul>
      </Box>
    );
};

export default TaskListProgressBar;
